import React from "react";
import { Modal, Button } from "react-bootstrap";

function VtermResultModal({ result, onClose }) {
  if (!result) return null;

  const isSuccess = result.success === 1;
  const title = isSuccess ? "Payment Successful" : "Payment Declined";
  const message = isSuccess
    ? "Purchase processed successfully."
    : (result.message || "Payment was declined.");
  const transactionId = result.data?.nmi_transaction_id || result.data?.transaction_id;

  return (
    <Modal lg={"medium"} show={!!result} onHide={onClose}>
      <Modal.Header className="no-border">
        <h4 className="m-0 font-weight-bold">{title}</h4>
        <Button
          title={"Info"}
          type="button"
          onClick={onClose}
          className="close-btn"
          data-dismiss="modal"
        >
          <i className="nc-icon nc-simple-remove"></i>
        </Button>
      </Modal.Header>
      <Modal.Body className="modal-data-body">
        <p className="theme-color">{message}</p>
        {isSuccess && transactionId && (
          <p className="theme-color">Transaction ID: <strong>{transactionId}</strong></p>
        )}
        {result.data?.auth_code && (
          <p className="theme-color">Auth Code: <strong>{result.data.auth_code}</strong></p>
        )}
        {result.data?.auth_code && (
          <p className="theme-color" style={{ fontStyle: "italic", fontSize: "13px" }}>
            Please save this auth code and transaction ID for your records. It may be required to verify or reference this transaction. A receipt has also been emailed to you.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ minWidth: "93px" }}
          onClick={onClose}
          type="button"
          className={`btn btn-fill ${isSuccess ? "btn-info" : "btn-danger"}`}
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VtermResultModal;
